import { render } from "./EditRegionSkillRankingModal.vue?vue&type=template&id=1f1f7ae6&scoped=true"
import script from "./EditRegionSkillRankingModal.vue?vue&type=script&lang=js"
export * from "./EditRegionSkillRankingModal.vue?vue&type=script&lang=js"

import "./EditRegionSkillRankingModal.vue?vue&type=style&index=0&id=1f1f7ae6&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1f7ae6"]])

export default __exports__